module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: this.currentOrgId
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar2",
    attrs: {
      "md-position": 'bottom right',
      "md-duration": 6000
    }
  }, [_vm._l((_vm.snackbar.errors), function(item) {
    return _c('span', {
      key: item
    }, [_vm._v(" " + _vm._s(item.message))])
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Ok")])], 2), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": _vm.vertical + ' ' + _vm.horizontal,
      "md-duration": _vm.duration
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")(_vm.sMessage)) + ".")]), _vm._v(" "), _c('md-button', {
    class: _vm.snackbarStyle,
    on: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Ok")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "confirmMessage",
    attrs: {
      "md-title": _vm._f("translate")('global.~ALERTA~'),
      "md-content-html": _vm._f("translate")(_vm.dMessage),
      "md-ok-text": _vm._f("translate")('global.~ACEPTAR~'),
      "md-cancel-text": _vm._f("translate")('global.~CANCELAR~')
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "dialogAlert",
    attrs: {
      "md-title": _vm._f("translate")('global.~ALERTA~'),
      "md-content": _vm._f("translate")(_vm.dMessage),
      "md-ok-text": _vm._f("translate")('global.~ACEPTAR~')
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1018
// module chunks = 14